import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { Footer } from '@/components/generals/footer'
import { Header } from '@/components/generals/header'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <div className='relative flex min-h-screen flex-col'>
            <a
                href='#main'
                className='sr-only z-[80] rounded-full bg-primary px-5 py-3 text-sm font-medium text-primary-foreground focus:not-sr-only focus:fixed focus:left-4 focus:top-4'
            >
                Skip to content
            </a>

            <div aria-hidden='true' className='scroll-progress fixed inset-x-0 top-0 z-[60] h-0.5 bg-primary' />

            <Header />

            <main id='main' className='flex-1'>
                {children}
            </main>

            <Footer />

            <div aria-hidden='true' className='grain' />
        </div>
    )
}
